import {
  LayoutDashboard, Users, Calendar, Stethoscope,
  Building2, Settings, UserCog, Smile, FileText, Banknote,
  ClipboardList, ShoppingBag, Pill, Tags,
} from 'lucide-react';

// Navigation items. An entry with `children` is a collapsible group rather
// than a page; its children keep their OWN adminOnly, so a receptionist sees
// the group holding only what they may actually open, and an empty group is
// not rendered at all.
//
// Every item carries both `labelKey` (an app_lang key) and `labelFallback`
// (English), so the UI degrades to English rather than to a raw key if the
// database is unreachable.
export const NAV_ITEMS = [
  { id: 'dashboard', labelKey: 'dashboard', labelFallback: 'Dashboard', Icon: LayoutDashboard },
  { id: 'queue', labelKey: 'patient_queue', labelFallback: 'Patient Queue', Icon: ClipboardList },
  { id: 'appointments', labelKey: 'appointments', labelFallback: 'Appointments', Icon: Calendar },
  { id: 'patients', labelKey: 'patients', labelFallback: 'Patients', Icon: Users },
  { id: 'odontogram', labelKey: 'odontogram', labelFallback: 'Odontogram', Icon: Smile },
  { id: 'certificates', labelKey: 'medical_certificate', labelFallback: 'Medical Certificate', Icon: FileText },
  { id: 'billing', labelKey: 'billing', labelFallback: 'Billing', Icon: Banknote },
  {
    id: 'branch_setting',
    labelKey: 'branch_setting',
    labelFallback: 'Branch Setting',
    Icon: Settings,
    children: [
      { id: 'branches', labelKey: 'branches', labelFallback: 'Branches', Icon: Building2, adminOnly: true },
      { id: 'dentists', labelKey: 'dentist_management', labelFallback: 'Dentist Management', Icon: UserCog, adminOnly: true },
      { id: 'label_settings', labelKey: 'label_settings', labelFallback: 'Label Settings', Icon: Tags, adminOnly: true },
      { id: 'medications', labelKey: 'medications', labelFallback: 'Medications', Icon: Pill, adminOnly: true },
      { id: 'shop', labelKey: 'shop', labelFallback: 'Shop', Icon: ShoppingBag, adminOnly: true },
      { id: 'treatments', labelKey: 'treatments', labelFallback: 'Treatments', Icon: Stethoscope },
    ],
  },
];

// Bottom tab bar on the phone shell (spec §4.1) - four real pages, none of
// them admin-only.
export const BOTTOM_NAV_IDS = ['dashboard', 'queue', 'appointments', 'patients'];

// Filters `adminOnly` entries, including inside `children`, given a predicate
// rather than importing `isAdmin` directly so callers (and tests) can drive
// it either way without mocking a module.
export function visibleNavItems(isAdminFn) {
  const admin = !!isAdminFn && isAdminFn();
  return NAV_ITEMS
    .filter((item) => !item.adminOnly || admin)
    .map((item) => {
      if (!item.children) return item;
      const children = item.children.filter((child) => !child.adminOnly || admin);
      return { ...item, children };
    });
}

// Flattens a list to every item including children, defaulting to the full
// set. Called bare for the More sheet, and as
// `flattenNavItems(visibleNavItems(isAdmin))` to flatten an already-filtered
// list.
export function flattenNavItems(items = NAV_ITEMS) {
  return items.reduce((acc, item) => {
    acc.push(item);
    if (item.children) acc.push(...item.children);
    return acc;
  }, []);
}
